exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".preview-text[data-v-30548a22]{margin-top:6px}.preview-sentence-case[data-v-30548a22]:first-letter{text-transform:capitalize}.edit-link img[data-v-30548a22]{width:25px}.form-text[data-v-30548a22]{font-weight:700;margin-top:10px}.title-text[data-v-30548a22]{padding:0;margin:8px 0}.flat-btn[data-v-30548a22]{margin:0}", ""]);

// exports
